import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import preloadAssets from './utils/preloader';
import './App.css';
import './styles/loader.css';
import Building3DGenerator from './components/Building3DGenerator/Building3DGenerator';


// Lazy loading компонентов
const LandingPage = lazy(() => import('./components/pages/LandingPage'));
const MapDemo = lazy(() => import('./components/pages/MapDemo'));
const PricingPage = lazy(() => import('./components/pages/PricingPage'));
const DemoClient = lazy(() => import('./components/DemoClient/DemoClient'));

const LoadingFallback = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#0A0A0F',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9998
  }}>
    <div className="mapi-app-loading">
      <div className="mapi-app-loading-spinner">
        <div className="mapi-app-loading-dot"></div>
        <div className="mapi-app-loading-dot"></div>
        <div className="mapi-app-loading-dot"></div>
        <div className="mapi-app-loading-dot"></div>
        <div className="mapi-app-loading-dot"></div>
        <div className="mapi-app-loading-dot"></div>
        <div className="mapi-app-loading-dot"></div>
        <div className="mapi-app-loading-dot"></div>
      </div>
    </div>
  </div>
);

function App() {
  useEffect(() => {
    // Скрываем начальный загрузчик
    document.body.classList.add('app-loaded');
    
    // 🔇 ПОДАВЛЯЕМ ЛИШНИЕ ОШИБКИ В КОНСОЛИ
    const originalWarn = console.warn;
    const originalError = console.error;
    
    console.warn = (...args) => {
      const message = args[0]?.toString?.() || '';
      if (message.includes('React Router Future Flag Warning')) {
        return; // Игнорируем предупреждения React Router
      }
      originalWarn.apply(console, args);
    };
    
    console.error = (...args) => {
      const message = args[0]?.toString?.() || '';
      if (message.includes('MetaMask') || 
          message.includes('ethereum') || 
          message.includes('inpage.js') ||
          message.includes('Ak: Disconnected')) {
        return; // Игнорируем ошибки криптокошельков
      }
      originalError.apply(console, args);
    };

    // 🎯 ЗАПУСКАЕМ УМНУЮ ПРЕДЗАГРУЗКУ (один раз)
    const initPreload = () => {
      // Ждем пока DOM будет готов
      if (document.readyState === 'complete') {
        preloadAssets();
      } else {
        window.addEventListener('load', preloadAssets, { once: true });
      }
    };

    // Небольшая задержка для стабильности
    setTimeout(initPreload, 1500);

  }, []);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="app-container">
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/demo" element={<MapDemo />} />
            <Route path="/democlient" element={<DemoClient />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="*" element={<LandingPage />} />
            <Route path="/3d-generator" element={<Building3DGenerator />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;